import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name: "decodeUri",
})
export class DecodeURIPipe implements PipeTransform {

    transform(uri: string): string {
        return decodeURI(uri)
    }

}